import styled from "styled-components"
import { Button, Input, Typography, message, Row, Col, Modal } from "../../../ui/ot"
import { useTranslation } from "react-i18next";
import { useMARCFile2Json } from './../../controllers/MARCFile2JsonController'
import React, { useState } from "react";
import dayjs from 'dayjs';
import { useBib } from "../../controllers/BibController";
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from "../../../ui/table"
const StageMARCRecord = () => {
    const thisJS = "StageMARCRecord"
    const { t } = useTranslation('translation', { keyPrefix: 'library.stage_marc_record' });
    const [lastUploadTime, setLastUploadTime] = useState(undefined)
    const [importFailed, setImportFailed] = useState([])
    const [importDuplicate, setImportDuplicate] = useState([])
    const [loading, setLoading] = useState(false)
    const onUpload = (e) => {
        let file = null
        for (let index = 0; index < e.target.files.length; index++) {
            file = e.target.files[index];
        }
        let form_data = new FormData();
        form_data.append('file', file);
        // console.log(thisJS, "onUpload", form_data)
        postMARCFile2JsonData(form_data)
        setImportFailed([]); setImportDuplicate([]);
    }
    const onFormFinish = () => {
        //const aMarc = MARCFile2JsonData?.data?.map(mapItem => {
        //    return { metadata: { ...mapItem } }
        //})
        setLoading(true)
        postBibData(MARCFile2JsonData)
    }

    const {
        MARCFile2JsonData,
        postMARCFile2JsonData
    } = useMARCFile2Json({
        onBefore: ({ axiosMode, values }) => {
            // console.log(thisJS, "postMARCFile2JsonData OnBefore", values)
        },
        onFinish: ({ axiosMode, status, values }) => {
            // console.log(thisJS, "postMARCFile2JsonData onFinish", status, values)
            if (status === "success") {
                if (axiosMode === "post") {
                    setLastUploadTime(dayjs().format('YYYY-MM-DD HH:mm'))
                }
            }
            else {
                message.error(values?.message|| "檔案轉換失敗")
                return;
            }

        }
    })
    const {
        postBibData
    } = useBib({
        onBefore: ({ axiosMode, values }) => {
            // console.log(thisJS, "postBibData onBefore", values)
        },
        onFinish: ({ axiosMode, status, values }) => {
            // console.log(thisJS, "postBibData onFinish", axiosMode, status, values)
            setLoading(false)
            if (status === "error") {
                message.error(values?.message)
                return;
            }

            if (axiosMode === "post") {
                const _importDuplicate = [];
                const _importFailed = [];
                values.data.forEach((oMarc) => {
                    if (oMarc.result.status === "failed") {
                        // console.log(thisJS, "failed", oMarc.result)
                        if (oMarc.result.message.startsWith("重複的書目")) {
                            _importDuplicate.push(oMarc);
                        } else {
                            _importFailed.push(oMarc);
                        }
                    }
                })
                const cUploadResult = t("uploadResult").replace("failedCount", _importDuplicate.length + _importFailed.length).replace("DuplicateCount", _importDuplicate.length)
                message.success(cUploadResult)
                setImportFailed(_importFailed);
                setImportDuplicate(_importDuplicate);

            }
        },
    })
    return (<>

        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row justify="center" gutter={[8, 8]}>
                    <Col xxl={12} xl ={12} lg={12} sm={20} md={24} xs={24} >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Title>{t('Stage_MARC_records_for_import')}</Title>

                            </Col>
                            <Col span={24}>
                                <PScontext>
                                    • {t('Select_a_MARC_file_to_stage_in_the_import_reservoir_It_will_be_parsed_and_each_valid_record_staged_for_later_import_into_the_catalog')}
                                </PScontext>
                            </Col>
                            {/* <Col span={24}>
                                <PScontext>
                                    • {t('You_can_enter_a_name_for_this_import_It_may_be_useful_when_creating_a_record_to_remember_where_the_suggested_MARC_data_comes_from')}
                                </PScontext>
                            </Col> */}
                            <Col span={24}>
                                <Input type="file" accept=".mrc,.marc,.mrk,.iso,.out" onChange={onUpload} />

                            </Col>

                            {lastUploadTime && <Col span={24}> <Typography.P>{t("最後暫存時間")}：{lastUploadTime}</Typography.P>  </Col>}
                            {lastUploadTime && <Col span={24}> <Typography.P>{t("最後暫存筆數")}：{MARCFile2JsonData?.length ?? 0}</Typography.P> </Col>}
                            {lastUploadTime && <Col span={24}> <Typography.P>{t("內含重複筆數")}：{
                                (MARCFile2JsonData || []).reduce(
                                    (sum, { bib_isbn_exist }) => sum + (bib_isbn_exist ? 1 : 0), 0
                                )
                            }</Typography.P> </Col>}
                            {lastUploadTime && <Col span={24}>
                                <Typography.P>{t("重複書目清單")}：</Typography.P>
                                <ul> {
                                    (MARCFile2JsonData || []).map((marcData) => {
                                        if (marcData.bib_isbn_exist) {
                                            return (
                                                <li key={marcData.key}>{marcData.bib_title}</li>
                                            )
                                        } else {
                                            return (<React.Fragment key={marcData.key}></React.Fragment>)
                                        }
                                    })
                                }</ul>
                            </Col>}

                            <Col span={24}>
                                <Button
                                    style={{ width: '100%' }}
                                    loading={loading}
                                    onClick={onFormFinish}>
                                    {t('upload_file')}
                                </Button>
                            </Col>
                            <Col span={24}>
                                {importDuplicate.length > 0 && <>
                                    <Typography.P>{t("重複書目清單")}：</Typography.P>
                                    <ul> {
                                        importDuplicate.map((marcData) => {
                                            return (
                                                <li key={marcData.key}>{marcData.bib_title}</li>
                                            )
                                        })
                                    }</ul>
                                </>}
                            </Col>
                        </Row>
                    </Col>
                    {MARCFile2JsonData.length > 0 && (
                        <Col  xxl={12} xl ={12} lg={12} sm={20} md={24} xs={24}>
                            <Row>
                                <Col span={24}>
                                    <Table style={{ width: '100%', height: '90vh' }}>
                                        <TableHeader
                                            style={{ position: 'sticky' }}
                                        >
                                            <TableRow>
                                                <TableHead className="w-[80px]" >#  </TableHead>
                                                <TableHead className="w-[200px]">書目名稱</TableHead>
                                                <TableHead>作者</TableHead>
                                                <TableHead>ISBN</TableHead>
                                                <TableHead className="w-[100px]">是否已存在</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody style={{}}>
                                            {MARCFile2JsonData?.map((value) => (
                                                <TableRow key={value?.key}>
                                                    <TableCell  ><Button type="link" onClick={() => {
                                                        Modal.info({
                                                            width: '1000px',
                                                            title: value?.bib_title,
                                                            okText: "關閉",
                                                            content: <Row>
                                                                <Col span={24}>
                                                                    <Row>
                                                                        <Col span={24}>
                                                                            <Row>
                                                                                <Col span={3}>
                                                                                    leader
                                                                                </Col>
                                                                                <Col span={21}>
                                                                                    {value?.metadata?.leader}
                                                                                </Col>
                                                                            </Row>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={24}>
                                                                    <Row>
                                                                        {value?.metadata?.controlfield.map((field) => {
                                                                            return (
                                                                                <Col span={24}>
                                                                                    <Row>
                                                                                        <Col span={3}>
                                                                                            {field?.tag}
                                                                                        </Col>
                                                                                        <Col span={21}>
                                                                                            {field?.text}
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            )
                                                                        })}
                                                                    </Row>
                                                                </Col>
                                                                <Col span={24}>
                                                                    <Row  gutter={[8 ,8]}>
                                                                        {value?.metadata?.datafield.map((field) => {
                                                                            return (
                                                                                <Col span={24}>
                                                                                    <Row>
                                                                                        <Col span={3}>
                                                                                            <Row gutter={[4, 4]}>
                                                                                                <Col>
                                                                                                    {field?.tag}
                                                                                                </Col>
                                                                                                <Col>
                                                                                                    {field?.ind1}
                                                                                                </Col>
                                                                                                <Col>
                                                                                                    {field?.ind2}
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Col>
                                                                                        <Col span={21}>
                                                                                            <Row>
                                                                                                {
                                                                                                    field?.subfield?.map((sub)=>{
                                                                                                        return (
                                                                                                            <Col span={24}>
                                                                                                            <Row  gutter={[4, 4]} >
                                                                                                                <Col>
                                                                                                                    {sub?.code}
                                                                                                                </Col>
                                                                                                                <Col>
                                                                                                                    {sub?.text}
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        </Col>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </Row>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </Col>
                                                                            )
                                                                        })}
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        })
                                                    }}>{value?.key}</Button>
                                                    </TableCell>
                                                    <TableCell className="font-medium">{value?.bib_title}</TableCell>
                                                    <TableCell>{value?.bib_author}</TableCell>
                                                    <TableCell>{value?.bib_isbn.find(_ => true)}</TableCell>
                                                    <TableCell  >{value?.bib_isbn_exist ? "重複書目" : "可新增"}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell colSpan={4}>總筆數</TableCell>
                                                <TableCell className="text-right">{MARCFile2JsonData.length}</TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                    )}
                </Row>
            </Col>
        </Row>
    </>
    )
}


const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
-ms-flex-direction: column;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
flex-wrap: wrap;
`

const ContainerForm = styled.div`
display: flex;
flex-direction: column;
gap: inherit;
}
`

const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 600;
}
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
`

const SmallFlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
`

const Em20 = styled.div`
width: 20em;
`

export default StageMARCRecord
